import React from "react";
import './liveCustomLinks.css';
import {Helmet} from "react-helmet";
import {TitlePage} from "../../../shared";
import {useNavigate} from "react-router-dom";
import {getCachedImageUrl} from "../../../../utils/utils";
import UseLiveCustomLinks from "./hooks/useLiveCustomLinks";

const LiveCustomLinks = () => {

    const {links, setLinks, loading} = UseLiveCustomLinks();

    const navigate = useNavigate();

    const handleAddLink = (link, name) => {
        const newLink = {link: link.replace("acestream://", ""), name, id: Date.now().toString()};
        const updatedLinks = [...links, newLink];
        setLinks(updatedLinks);
    }

    return <div>

        <Helmet>
            <meta charSet="utf-8"/>
            <title>Live | Custom</title>
            <link rel="icon"
                  href={getCachedImageUrl("https://play-lh.googleusercontent.com/daJbjIyFdJ_pMOseXNyfZuy2mKOskuelsyUyj6AcGb0rV0sJS580ViqOTcSi-A1BUnI")}/>
        </Helmet>
        <TitlePage leftClass="col-10" icon=""
                   rightClass="col-2"
                   rightOptions={
                       <i className="fa-solid fa-xmark text-light fa-xl p-3" style={{
                           cursor: "pointer"
                       }} onClick={() => {
                           if (window.history.length <= 2) {
                               navigate("/squadflix/live");
                               return;
                           }

                           window.history.back()
                       }}></i>
                   }
                   title={
                       <div className="d-flex flex-row align-items-center">
                           <span className="ps-2">
                               Tus LINKS
                               </span>
                       </div>
                   }></TitlePage>
        <div className="d-flex flex-column align-items-center justify-content-center text-center mt-3 text-muted">
            <span>Aquí puedes gestionar tus links personalizados de AceStream.</span>
        </div>
        <div>
            {links.length === 0 &&
                <div className="d-flex flex-column align-items-center justify-content-center mt-5 text-muted">
                    <span>No tienes links personalizados añadidos.</span>
                    <span>Usa el botón de abajo para añadir uno.</span>
                </div>
            }
            {links.length > 0 &&
                <div className="d-flex flex-column align-items-center justify-content-center mt-3">
                    {links.map((link) => (
                        <div key={link.id} className="card mb-3" style={{width: '100%'}}>
                            <div className="card-body d-flex flex-column align-items-start">
                                <h5 className="card-title">{link.name}</h5>
                                <p className="card-text text-truncate" style={{maxWidth: '100%'}}>{link.link}
                                    <span className="ms-2" onClick={() => {
                                        navigator.clipboard.writeText(`acestream://${link.link}`);
                                        alert('Link copiado al portapapeles');
                                    }}><i className="fa-solid fa-copy"></i></span></p>
                                <div className="mt-auto d-flex flex-row">
                                    <button className="btn btn-primary me-2" onClick={() => {
                                        navigate(`/squadflix/live/custom/play/${link.id}`);
                                    }}>Ver
                                    </button>
                                    <button className="btn btn-danger" onClick={() => {
                                        const updatedLinks = links.filter(l => l.id !== link.id);
                                        setLinks(updatedLinks);
                                    }}>Eliminar
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
        </div>
        <div className="d-flex flex-row justify-content-center mt-4 mb-4">
            <button className="btn btn-success" data-bs-toggle="modal" data-bs-target="#addCustomLinkModal">
                <i className="fa-solid fa-plus me-2"></i>Añadir Link
            </button>
        </div>
        <div className="modal fade" id="addCustomLinkModal" tabIndex="-1" aria-labelledby="addCustomLinkModalLabel"
             aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="addCustomLinkModalLabel">Añadir Link Personalizado</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form id="addLinkForm" onSubmit={(e) => {
                            e.preventDefault();
                            const link = e.target.link.value.trim();
                            const name = e.target.name.value.trim();
                            if (link && name) {
                                handleAddLink(link, name);
                                e.target.link.value = '';
                                e.target.name.value = '';
                                const modal = window.bootstrap.Modal.getInstance(document.getElementById('addCustomLinkModal'));
                                modal.hide();
                            }
                        }}>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Nombre del Link</label>
                                <input type="text" className="form-control" id="name" name="name" required
                                       placeholder="Ejemplo: Canal 1"/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="link" className="form-label">Link AceStream</label>
                                <input type="text" className="form-control" id="link" name="link" required
                                       placeholder="Ejemplo: acestream://1234567890abcdef1234567890abcdef12345678"/>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        <button type="submit" form="addLinkForm" className="btn btn-primary">Añadir Link</button>
                    </div>
                </div>
            </div>
        </div>

    </div>;
}

export default LiveCustomLinks;
